export const replaceDotWithComma = (price) => {
    if (!price) {
        return '';
    }
    return price.toString().replace(/[.]/, ',');
};
export const formatToTwoDecimalPlacesRoundingUp = (price) => {
    if (typeof price !== 'number' && !price) {
        return '';
    }
    if (typeof price === 'string') {
        price = Number.parseFloat(price);
    }
    const priceMultiplied = stripUnnecessaryDecimals(price * Math.pow(10, 2));
    const priceWith2DecimalPlaces = (Math.ceil(priceMultiplied) / Math.pow(10, 2)).toFixed(2);
    if (+priceWith2DecimalPlaces === +(+priceWith2DecimalPlaces).toFixed(0)) {
        return (+priceWith2DecimalPlaces).toFixed(0);
    }
    return replaceDotWithComma(priceWith2DecimalPlaces);
};
const stripUnnecessaryDecimals = (price) => {
    const priceParts = `${price}`.split('.');
    if (priceParts.length === 2 && priceParts[1].startsWith('0')) {
        return Number(priceParts[0]);
    }
    return price;
};
const stripTrailingZeroes = (price) => {
    if (!price) {
        return '';
    }
    return price.endsWith(',00') ? price.substr(0, price.length - 3) : price;
};
export const formatPrice = (price) => {
    return stripTrailingZeroes(replaceDotWithComma(formatToTwoDecimalPlacesRoundingUp(price)));
};
